document.documentElement.classList.remove('no-js');

const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
  style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
}).format(cents / 100);

class QuantityInput extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('input');
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      const previous = input.value;
      button.name === 'plus' ? input.stepUp() : input.stepDown();
      if (previous !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

class TicketProduct extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('[data-variant-card]')];
    this.total = this.querySelector('[data-ticket-total]');
    this.count = this.querySelector('[data-ticket-count]');
    this.button = this.querySelector('[data-multi-add]');
    this.message = this.querySelector('[data-product-message]');
    this.buildFilters();
    this.querySelectorAll('[data-variant-qty]').forEach((input) => input.addEventListener('change', () => this.update()));
    this.button?.addEventListener('click', () => this.add());
    this.update();
  }
  parse(card) {
    const parts = card.dataset.variantTitle.split(/\s+(?:·|\/)\s+/).map((value) => value.trim());
    return { date: parts[0] || 'Toutes les dates', session: parts[1] || 'Toutes les sessions', category: parts.slice(2).join(' · ') || parts[parts.length - 1] || 'Billet' };
  }
  unique(key) {
    return [...new Set(this.cards.filter((card) => card.dataset.available === 'true').map((card) => this.parse(card)[key]))];
  }
  buildFilters() {
    ['date', 'session'].forEach((key) => {
      const zone = this.querySelector(`[data-filter="${key}"]`);
      if (!zone) return;
      const values = this.unique(key);
      if (values.length < 2) { zone.closest('.ticket-step')?.classList.add('is-static'); return; }
      values.forEach((value, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `choice-chip${index === 0 ? ' is-active' : ''}`;
        button.textContent = value;
        button.dataset.value = value;
        button.addEventListener('click', () => {
          zone.querySelectorAll('button').forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
          this.filterCards();
        });
        zone.append(button);
      });
    });
    this.filterCards();
  }
  filterCards() {
    const date = this.querySelector('[data-filter="date"] .is-active')?.dataset.value;
    const session = this.querySelector('[data-filter="session"] .is-active')?.dataset.value;
    this.cards.forEach((card) => {
      const parsed = this.parse(card);
      card.hidden = Boolean((date && parsed.date !== date) || (session && parsed.session !== session));
      card.querySelector('[data-category-name]').textContent = parsed.category;
    });
  }
  update() {
    let quantity = 0;
    let cents = 0;
    this.cards.forEach((card) => {
      const qty = Number(card.querySelector('[data-variant-qty]')?.value || 0);
      quantity += qty;
      cents += qty * Number(card.dataset.price);
      card.classList.toggle('is-selected', qty > 0);
    });
    this.count.textContent = `${quantity} place${quantity > 1 ? 's' : ''}`;
    this.total.textContent = money(cents);
    this.button.disabled = quantity === 0;
  }
  async add() {
    const items = this.cards.map((card) => ({
      id: Number(card.dataset.variantId), quantity: Number(card.querySelector('[data-variant-qty]')?.value || 0),
      properties: { '_Sélection': card.dataset.variantTitle }
    })).filter((item) => item.quantity > 0);
    if (!items.length) return;
    this.button.disabled = true;
    this.message.textContent = 'Ajout en cours…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('cart');
      sessionStorage.setItem('ticket-cart-start', String(Date.now()));
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      this.message.textContent = 'Une disponibilité a changé. Actualisez la page puis réessayez.';
      this.button.disabled = false;
    }
  }
}
if (!customElements.get('ticket-product')) customElements.define('ticket-product', TicketProduct);

class CartTimer extends HTMLElement {
  connectedCallback() {
    const duration = Number(this.dataset.minutes || 10) * 60000;
    let start = Number(sessionStorage.getItem('ticket-cart-start'));
    if (!start) { start = Date.now(); sessionStorage.setItem('ticket-cart-start', String(start)); }
    const tick = () => {
      const left = Math.max(0, duration - (Date.now() - start));
      const minutes = String(Math.floor(left / 60000)).padStart(2, '0');
      const seconds = String(Math.floor((left % 60000) / 1000)).padStart(2, '0');
      this.querySelector('[data-time]').textContent = `${minutes}:${seconds}`;
      this.querySelector('[data-timer-bar]').style.width = `${(left / duration) * 100}%`;
      if (left > 0) setTimeout(tick, 250);
    };
    tick();
  }
}
if (!customElements.get('cart-timer')) customElements.define('cart-timer', CartTimer);

class HospitalityBooking extends HTMLElement {
  connectedCallback() {
    this.day = null;
    this.time = null;
    this.space = null;
    this.package = null;
    this.isAdding = false;
    this.quantity = this.querySelector('[data-hp-quantity]');
    this.total = this.querySelector('[data-hp-total]');
    this.addButton = this.querySelector('[data-hp-add]');
    this.mobileAddButton = this.querySelector('[data-hp-add-mobile]');
    this.mobileTotal = this.querySelector('[data-hp-total-mobile]');
    this.mobileStatus = this.querySelector('[data-hp-mobile-status]');
    this.mobileCart = this.querySelector('.hp-mobile-cart');
    this.orderCard = this.querySelector('.hp-order-card');
    this.timeStage = this.querySelector('[data-hp-stage="time"]');
    this.spaceStage = this.querySelector('[data-hp-stage="space"]');
    this.message = this.querySelector('[data-hp-message]');
    try { this.variants = JSON.parse(this.querySelector('[data-hp-variants]')?.textContent || '[]'); } catch (error) { this.variants = []; }
    try { this.optionNames = JSON.parse(this.querySelector('[data-hp-options]')?.textContent || '[]'); } catch (error) { this.optionNames = []; }
    this.optionNames = this.optionNames.map((option) => typeof option === 'string' ? option : option?.name || '');
    this.optionPositions = {
      day: this.optionIndex(['journee', 'date'], 0),
      time: this.optionIndex(['plage horaire', 'horaire', 'session'], 1),
      space: this.optionIndex(['espace', 'salon', 'hospitalite'], 2)
    };
    this.optionsValid = new Set(Object.values(this.optionPositions)).size === 3 && this.optionNames.length === 3;
    this.querySelectorAll('[data-hp-filter]').forEach((button) => button.addEventListener('click', () => this.filter(button)));
    this.querySelectorAll('[data-hp-day]').forEach((button) => button.addEventListener('click', () => this.choose('day', button)));
    this.querySelectorAll('[data-hp-time]').forEach((button) => button.addEventListener('click', () => this.choose('time', button)));
    this.querySelectorAll('[data-hp-space]').forEach((button) => button.addEventListener('click', () => this.choose('space', button)));
    this.querySelectorAll('[data-hp-package]').forEach((button) => button.addEventListener('click', () => this.choosePackage(button)));
    this.quantity?.addEventListener('change', () => this.updateQuantity());
    this.quantity?.addEventListener('input', () => this.updateQuantity());
    this.addButton?.addEventListener('click', () => this.add());
    this.mobileAddButton?.addEventListener('click', () => this.add());
    if (this.mobileCart && this.orderCard && 'IntersectionObserver' in window) {
      this.summaryObserver = new IntersectionObserver(([entry]) => {
        this.mobileCart.classList.toggle('is-hidden', entry.isIntersecting);
      }, { threshold: 0.12 });
      this.summaryObserver.observe(this.orderCard);
    }
    const defaultDay = this.querySelector('[data-hp-day][data-default-selected]:not([disabled])');
    if (defaultDay) this.applySelection('day', defaultDay);
    const defaultTime = this.querySelector('[data-hp-time][data-default-selected]:not([disabled])');
    if (this.day && defaultTime) this.applySelection('time', defaultTime);
    const defaultSpace = this.querySelector('[data-hp-space][data-default-selected]:not([disabled])');
    if (this.time && defaultSpace) this.applySelection('space', defaultSpace);
    this.update();
  }
  disconnectedCallback() {
    this.summaryObserver?.disconnect();
  }
  filter(button) {
    this.querySelectorAll('[data-hp-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
    const phase = button.dataset.hpFilter;
    this.querySelectorAll('[data-hp-day]').forEach((day) => { day.hidden = phase !== 'all' && day.dataset.phase !== phase; });
    if (this.day?.hidden) {
      this.clearSelections(['day', 'time', 'space']);
      this.update();
    }
  }
  choose(type, button) {
    if (button.disabled) return;
    if (type === 'day') this.clearPackage();
    if (type === 'day' && this.day !== button) this.clearSelections(['time', 'space']);
    if (type === 'time' && this.time !== button) this.clearSelections(['space']);
    this.applySelection(type, button);
    this.update();
  }
  choosePackage(button) {
    if (button.disabled || !button.dataset.variantId || button.dataset.available !== 'true') return;
    this.clearSelections(['day', 'time', 'space']);
    this.querySelectorAll('[data-hp-package]').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    this.package = button;
    this.update();
  }
  applySelection(type, button) {
    this.querySelectorAll(`[data-hp-${type}]`).forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    this[type] = button;
  }
  clearSelections(types) {
    types.forEach((type) => {
      this[type] = null;
      this.querySelectorAll(`[data-hp-${type}]`).forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
    });
  }
  clearPackage() {
    this.package = null;
    this.querySelectorAll('[data-hp-package]').forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-pressed', 'false');
    });
  }
  syncStages() {
    if (this.timeStage) this.timeStage.hidden = Boolean(this.package) || !this.day;
    if (this.spaceStage) this.spaceStage.hidden = Boolean(this.package) || !this.time;
  }
  syncSummary() {
    if (this.package) {
      ['day', 'time', 'space'].forEach((type) => {
        const summary = this.querySelector(`[data-hp-summary="${type}"]`);
        summary?.classList.add('is-done');
        const value = summary?.querySelector('dd');
        if (value) value.textContent = type === 'day'
          ? this.package.dataset.label
          : type === 'time' ? 'Comprise dans le forfait' : 'Compris dans le forfait';
      });
      return;
    }
    ['day', 'time', 'space'].forEach((type) => {
      const summary = this.querySelector(`[data-hp-summary="${type}"]`);
      const selection = this[type];
      summary?.classList.toggle('is-done', Boolean(selection));
      const value = summary?.querySelector('dd');
      if (value) value.textContent = selection ? selection.dataset.summaryLabel || selection.dataset.label : 'À choisir';
    });
  }
  normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr-FR')
      .replace(/[’']/g, ' ').replace(/[–—-]/g, ' ').replace(/\b2027\b/g, ' ')
      .replace(/\b(lundi|mardi|mercredi|jeudi|vendredi|samedi|dimanche)\b/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  optionIndex(aliases, fallback) {
    const index = this.optionNames.findIndex((name) => aliases.some((alias) => this.normalize(name).includes(alias)));
    return index >= 0 ? index : fallback;
  }
  valuesMatch(selected, candidate) {
    const normalizedSelected = this.normalize(selected);
    const normalizedCandidate = this.normalize(candidate);
    if (normalizedSelected === normalizedCandidate) return true;
    const selectedTokens = normalizedSelected.split(' ').filter(Boolean);
    const candidateTokens = normalizedCandidate.split(' ').filter(Boolean);
    if (!selectedTokens.length || !candidateTokens.length) return false;
    return selectedTokens.every((token) => candidateTokens.includes(token)) || candidateTokens.every((token) => selectedTokens.includes(token));
  }
  findVariant(dayValue, timeValue, spaceValue) {
    if (!dayValue || !timeValue || !spaceValue) return null;
    const exactMatches = this.variants.filter((variant) => {
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      return this.normalize(dayValue) === this.normalize(options[this.optionPositions.day])
        && this.normalize(timeValue) === this.normalize(options[this.optionPositions.time])
        && this.normalize(spaceValue) === this.normalize(options[this.optionPositions.space]);
    });
    if (exactMatches.length) return exactMatches.find((variant) => variant.available) || exactMatches[0];
    const matches = this.variants.filter((variant) => {
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      return this.valuesMatch(dayValue, options[this.optionPositions.day])
        && this.valuesMatch(timeValue, options[this.optionPositions.time])
        && this.valuesMatch(spaceValue, options[this.optionPositions.space]);
    });
    return matches.find((variant) => variant.available) || matches[0] || null;
  }
  hasAvailableVariant(dayValue, timeValue, spaceValue) {
    return this.variants.some((variant) => {
      if (!variant.available) return false;
      const options = variant.options || [variant.option1, variant.option2, variant.option3];
      return (!dayValue || this.valuesMatch(dayValue, options[this.optionPositions.day]))
        && (!timeValue || this.valuesMatch(timeValue, options[this.optionPositions.time]))
        && (!spaceValue || this.valuesMatch(spaceValue, options[this.optionPositions.space]));
    });
  }
  syncAvailability() {
    if (!this.variants.length || !this.optionsValid) return;
    this.querySelectorAll('[data-hp-time]').forEach((option) => {
      option.disabled = !this.hasAvailableVariant(this.day?.dataset.value, option.dataset.value, null);
    });
    this.querySelectorAll('[data-hp-space]').forEach((option) => {
      option.disabled = !this.hasAvailableVariant(this.day?.dataset.value, this.time?.dataset.value, option.dataset.value);
    });
  }
  updateQuantity() {
    if (!this.quantity) return this.update();
    const minimum = Number(this.quantity.min || 1);
    const maximum = Number(this.quantity.max || 99);
    const parsed = Number.parseInt(this.quantity.value, 10);
    this.quantity.value = String(Math.min(maximum, Math.max(minimum, Number.isFinite(parsed) ? parsed : minimum)));
    this.update();
  }
  update() {
    this.syncStages();
    this.syncSummary();
    this.syncAvailability();
    const quantity = Math.max(1, Number(this.quantity?.value || 1));
    const dayCents = Number(this.day?.dataset.price || 0);
    const timeCents = Number(this.time?.dataset.price || 0);
    const spaceCents = Number(this.space?.dataset.price || 0);
    const packageVariant = this.package ? {
      id: Number(this.package.dataset.variantId),
      price: Number(this.package.dataset.price),
      available: this.package.dataset.available === 'true'
    } : null;
    this.variant = packageVariant || this.findVariant(this.day?.dataset.value, this.time?.dataset.value, this.space?.dataset.value);
    const unitCents = Number(this.variant?.price ?? (dayCents + timeCents + spaceCents));
    const cents = unitCents * quantity;
    this.querySelectorAll('[data-hp-time]').forEach((option) => {
      const livePrice = option.querySelector('[data-hp-live-price]');
      const variant = this.findVariant(this.day?.dataset.value, option.dataset.value, this.space?.dataset.value);
      if (livePrice) livePrice.textContent = variant ? money(Number(variant.price)) : (this.day ? `dès ${money(dayCents + Number(option.dataset.price || 0))}` : '—');
    });
    this.querySelectorAll('[data-hp-space]').forEach((option) => {
      const livePrice = option.querySelector('[data-hp-live-price]');
      const variant = this.findVariant(this.day?.dataset.value, this.time?.dataset.value, option.dataset.value);
      if (livePrice) livePrice.textContent = variant ? money(Number(variant.price)) : (this.day ? money(dayCents + timeCents + Number(option.dataset.price || 0)) : '—');
    });
    const selections = this.package ? [this.package, this.package, this.package] : [this.day, this.time, this.space];
    const progressSteps = [...document.querySelectorAll('.hp-progress__step')];
    const firstIncomplete = selections.findIndex((selection) => !selection);
    const activeStep = firstIncomplete < 0 ? progressSteps.length - 1 : firstIncomplete;
    selections.forEach((selection, index) => {
      progressSteps[index]?.classList.toggle('is-complete', Boolean(selection));
      progressSteps[index]?.classList.toggle('is-active', index === activeStep);
    });
    const complete = Boolean(this.variant?.available && (this.package || (this.day && this.time && this.space)));
    if (complete) {
      const variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set('variant', String(this.variant.id));
      window.history.replaceState({}, '', variantUrl);
    }
    if (this.total) this.total.textContent = complete ? money(cents) : '—';
    const unit = this.querySelector('[data-hp-unit]');
    if (unit) unit.textContent = complete ? `${money(unitCents)} × ${quantity} personne${quantity > 1 ? 's' : ''}` : '';
    if (this.addButton) this.addButton.disabled = !complete || this.isAdding;
    if (this.mobileAddButton) this.mobileAddButton.disabled = !complete || this.isAdding;
    if (this.mobileTotal) this.mobileTotal.textContent = complete ? money(cents) : '—';
    if (this.mobileStatus) this.mobileStatus.textContent = this.package
      ? `${this.package.dataset.label} · ${quantity} personne${quantity > 1 ? 's' : ''}`
      : this.day
      ? `${this.day.dataset.label}${complete ? ` · ${quantity} personne${quantity > 1 ? 's' : ''}` : ''}`
      : 'Choisissez votre journée';
    if (!this.message) return;
    if (this.package) this.message.textContent = 'Forfait tout compris : rien d’autre à sélectionner.';
    else if (!this.variants.length) this.message.textContent = 'Associez le produit Hospitalités à cette section ou utilisez le modèle product.hospitalites.';
    else if (!this.optionsValid) this.message.textContent = 'Les trois options du produit doivent s’appeler Journée, Plage horaire et Espace.';
    else if (!this.day) this.message.textContent = 'Sélectionnez une journée pour commencer.';
    else if (!this.time) this.message.textContent = 'Choisissez ensuite une plage horaire.';
    else if (!this.space) this.message.textContent = 'Choisissez enfin votre espace de réception.';
    else if (!this.variant) this.message.textContent = 'Cette combinaison de variantes n’existe pas dans le produit Shopify.';
    else if (!this.variant.available) this.message.textContent = 'Cette combinaison est actuellement complète.';
    else this.message.textContent = 'Votre sélection est prête.';
  }
  async add() {
    const selectionComplete = Boolean(this.package || (this.day && this.time && this.space));
    if (this.isAdding || !this.variant?.id || !this.variant.available || !selectionComplete) return;
    this.isAdding = true;
    if (this.addButton) { this.addButton.disabled = true; this.addButton.setAttribute('aria-busy', 'true'); }
    if (this.mobileAddButton) { this.mobileAddButton.disabled = true; this.mobileAddButton.setAttribute('aria-busy', 'true'); }
    if (this.message) this.message.textContent = 'Ajout en cours…';
    const properties = this.package ? {
      'Journée': this.package.dataset.label,
      'Plage horaire': 'Comprise dans le forfait',
      'Espace': 'Compris dans le forfait'
    } : {
      'Journée': this.day.dataset.label,
      'Plage horaire': this.time.dataset.label,
      'Espace': this.space.dataset.label
    };
    const item = {
      id: Number(this.variant.id),
      quantity: Math.max(1, Number(this.quantity?.value || 1)),
      properties
    };
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!response.ok) {
        const cartError = await response.json().catch(() => ({}));
        throw new Error(cartError.description || cartError.message || 'cart');
      }
      sessionStorage.setItem('ticket-cart-start', String(Date.now()));
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      this.isAdding = false;
      if (this.message) this.message.textContent = error.message && error.message !== 'cart' ? error.message : 'Cette offre n’est plus disponible. Actualisez la page puis réessayez.';
      const canRetry = Boolean(this.variant?.available && (this.package || (this.day && this.time && this.space)));
      if (this.addButton) { this.addButton.disabled = !canRetry; this.addButton.removeAttribute('aria-busy'); }
      if (this.mobileAddButton) { this.mobileAddButton.disabled = !canRetry; this.mobileAddButton.removeAttribute('aria-busy'); }
    }
  }
}
if (!customElements.get('hospitality-booking')) customElements.define('hospitality-booking', HospitalityBooking);

class CourtTicketProduct extends HTMLElement {
  connectedCallback() {
    try {
      this.variants = JSON.parse(this.querySelector('[data-court-variants]')?.textContent || '[]');
      this.optionNames = JSON.parse(this.querySelector('[data-court-options]')?.textContent || '[]');
    } catch (_) {
      this.variants = [];
      this.optionNames = [];
    }
    this.dateIndex = this.findOptionIndex(['journee', 'date']);
    this.sessionIndex = this.findOptionIndex(['session', 'plage horaire']);
    this.categoryIndex = this.findOptionIndex(['categorie', 'category']);
    this.colors = ['#bf4a00', '#f25400', '#fa9258', '#f4c3a4'];
    this.quantity = this.querySelector('[data-quantity]');
    this.addButton = this.querySelector('[data-add-to-cart]');
    this.message = this.querySelector('[data-product-message]');
    this.selected = { date: null, session: null, category: null };
    this.isAdding = false;
    if (this.dateIndex < 0 || this.sessionIndex < 0 || this.categoryIndex < 0 || !this.variants.length) {
      if (this.message) this.message.textContent = 'Les options Journée, Session et Catégorie sont nécessaires.';
      return;
    }
    this.renderTribuneNumbers();
    this.bindPlan();
    this.renderDates();
    this.selectDate(this.values(this.dateIndex)[0]);
    this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => this.changeQuantity(-1));
    this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => this.changeQuantity(1));
    this.quantity?.addEventListener('change', () => this.changeQuantity(0));
    this.addButton?.addEventListener('click', () => this.addToCart());
  }
  normalize(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }
  findOptionIndex(aliases) {
    return this.optionNames.findIndex((name) => aliases.some((alias) => this.normalize(name).includes(alias)));
  }
  values(index, filters = {}) {
    const values = [];
    this.variants.forEach((variant) => {
      const matches = Object.entries(filters).every(([key, value]) => !value || variant.options[Number(key)] === value);
      if (matches && variant.available && !values.includes(variant.options[index])) values.push(variant.options[index]);
    });
    return values;
  }
  roundForDate(value) {
    const text = this.normalize(value);
    const day = Number((text.match(/\b(\d{1,2})\b/) || [])[1]);
    if (!day) return '';
    if (/juin/.test(text)) {
      return ({1:'1/4 finale',2:'1/4 finale',3:'1/2 finale dames',4:'1/2 finale hommes',5:'finale dames',6:'finale hommes'})[day] || '';
    }
    if (day <= 25) return '1er tour';
    if (day <= 27) return '2e tour';
    if (day <= 29) return '3e tour';
    return '1/8 finale';
  }
  shortDate(value) {
    const words = String(value).trim().split(/\s+/);
    const date = words.length > 2 ? words.slice(1).join(' ') : value;
    const round = this.roundForDate(value);
    return round ? `${date} (${round})` : date;
  }
  categoryLabel(index) {
    return ['Cat. OR', 'Cat. 1', 'Cat. 2', 'Cat. 3'][index] || `Cat. ${index}`;
  }
  renderTribuneNumbers() {
    const holder = this.querySelector('[data-tribune-numbers]');
    if (!holder || holder.childElementCount) return;
    const svgNamespace = 'http://www.w3.org/2000/svg';
    const labels = [];
    for (let tribune = 1; tribune <= 40; tribune += 1) {
      const angle = (-Math.PI / 2) + ((tribune - 1) * Math.PI * 2 / 40);
      const label = document.createElementNS(svgNamespace, 'text');
      label.setAttribute('x', String(260 + (176 * Math.cos(angle))));
      label.setAttribute('y', String(316 + (235 * Math.sin(angle))));
      label.setAttribute('text-anchor', 'middle');
      label.setAttribute('dominant-baseline', 'middle');
      label.textContent = String(tribune);
      labels.push(label);
    }
    holder.replaceChildren(...labels);
  }
  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency', currency:'EUR'}).format((Number(cents) || 0) / 100);
  }
  makeChoice(value, label, callback, selected = false) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `court-choice${selected ? ' is-selected' : ''}`;
    button.textContent = label;
    button.dataset.value = value;
    button.setAttribute('aria-pressed', String(selected));
    button.addEventListener('click', () => callback(value));
    return button;
  }
  renderDates() {
    const holder = this.querySelector('[data-date-options]');
    holder.replaceChildren(...this.values(this.dateIndex).map((value) => this.makeChoice(value, this.shortDate(value), (next) => this.selectDate(next), value === this.selected.date)));
  }
  selectDate(value) {
    this.selected.date = value;
    this.selected.session = null;
    this.selected.category = null;
    this.renderAll();
  }
  selectSession(value) {
    this.selected.session = value;
    this.selected.category = null;
    this.renderAll();
  }
  selectCategory(value) {
    this.selected.category = value;
    this.renderAll();
  }
  availableCategories() {
    if (!this.selected.date || !this.selected.session) return [];
    return this.values(this.categoryIndex, {[this.dateIndex]: this.selected.date, [this.sessionIndex]: this.selected.session});
  }
  currentVariant(category = this.selected.category) {
    return this.variants.find((variant) => variant.options[this.dateIndex] === this.selected.date && variant.options[this.sessionIndex] === this.selected.session && variant.options[this.categoryIndex] === category) || null;
  }
  renderAll() {
    this.renderDates();
    const sessionHolder = this.querySelector('[data-session-options]');
    const sessions = this.values(this.sessionIndex, {[this.dateIndex]: this.selected.date});
    sessionHolder.replaceChildren(...sessions.map((value) => this.makeChoice(value, value.replace(/^En /i, ''), (next) => this.selectSession(next), value === this.selected.session)));
    this.renderCategories();
    this.renderPlan();
    this.updatePurchase();
  }
  renderCategories() {
    const holder = this.querySelector('[data-category-options]');
    if (!this.selected.session) {
      holder.hidden = true;
      holder.replaceChildren();
      return;
    }
    holder.hidden = false;
    const allCategories = this.values(this.categoryIndex);
    const available = this.availableCategories();
    holder.replaceChildren(...allCategories.map((category, index) => {
      const variant = this.currentVariant(category);
      const button = document.createElement('button');
      const active = category === this.selected.category;
      const stock = Math.max(0, Number(variant?.inventory || 0));
      button.type = 'button';
      button.className = `court-category${active ? ' is-selected' : ''}`;
      button.disabled = !available.includes(category) || !variant?.available;
      button.dataset.category = category;
      button.style.setProperty('--category-color', this.colors[index] || this.colors[3]);
      button.setAttribute('aria-pressed', String(active));
      button.innerHTML = `<span class="court-category__color"></span><span><span class="court-category__name">${this.categoryLabel(index)}</span><span class="court-category__stock${stock > 0 && stock <= 11 ? ' is-low' : ''}">${stock > 11 ? `${stock} places restantes` : stock > 0 ? `Plus que ${stock} places` : 'Complet'}</span></span><strong class="court-category__price">${variant ? this.formatMoney(variant.price) : '—'}</strong>`;
      button.addEventListener('click', () => this.selectCategory(category));
      return button;
    }));
  }
  bindPlan() {
    this.querySelectorAll('[data-map-index]').forEach((zone) => {
      const activate = () => {
        const category = this.values(this.categoryIndex)[Number(zone.dataset.mapIndex)];
        if (category && this.availableCategories().includes(category)) this.selectCategory(category);
      };
      zone.addEventListener('click', activate);
      zone.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
      });
    });
  }
  renderPlan() {
    const categories = this.values(this.categoryIndex);
    const categorySelectionEnabled = Boolean(this.selected.session);
    this.querySelectorAll('[data-map-index]').forEach((zone) => {
      const category = categories[Number(zone.dataset.mapIndex)];
      zone.classList.toggle('is-selected', category === this.selected.category);
      zone.classList.toggle('is-disabled', !categorySelectionEnabled);
      zone.setAttribute('aria-pressed', String(category === this.selected.category));
      zone.setAttribute('aria-disabled', String(!categorySelectionEnabled));
      zone.setAttribute('tabindex', categorySelectionEnabled ? '0' : '-1');
    });
    const legend = this.querySelector('[data-plan-legend]');
    legend.replaceChildren(...categories.map((category, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = this.categoryLabel(index);
      button.className = category === this.selected.category ? 'is-selected' : '';
      button.style.setProperty('--category-color', this.colors[index] || this.colors[3]);
      button.setAttribute('aria-pressed', String(category === this.selected.category));
      button.disabled = !categorySelectionEnabled || !this.availableCategories().includes(category);
      button.addEventListener('click', () => this.selectCategory(category));
      return button;
    }));
  }
  changeQuantity(delta) {
    const variant = this.currentVariant();
    const maxSetting = Number(this.dataset.maxQuantity || 6);
    const stock = Number(variant?.inventory || maxSetting);
    const max = Math.max(1, Math.min(maxSetting, stock > 0 ? stock : maxSetting));
    const next = Math.max(1, Math.min(max, Number(this.quantity?.value || 1) + delta));
    if (this.quantity) { this.quantity.value = next; this.quantity.max = max; }
    this.updatePurchase();
  }
  updatePurchase() {
    const variant = this.currentVariant();
    const ready = Boolean(variant?.available && this.selected.date && this.selected.session && this.selected.category);
    this.changeQuantitySafely(variant);
    const quantity = Number(this.quantity?.value || 1);
    const subtotal = this.querySelector('[data-subtotal]');
    if (subtotal) subtotal.textContent = ready ? this.formatMoney(Number(variant.price) * quantity) : '—';
    if (this.addButton) this.addButton.disabled = !ready || this.isAdding;
    if (this.message) {
      if (ready) this.message.textContent = 'Votre sélection est prête.';
      else if (!this.selected.session) this.message.textContent = 'Choisissez une session pour afficher les catégories.';
      else if (!this.selected.category) this.message.textContent = 'Choisissez maintenant votre catégorie.';
      else this.message.textContent = 'Cette combinaison est indisponible.';
    }
    if (ready) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }
  changeQuantitySafely(variant) {
    if (!this.quantity) return;
    const maxSetting = Number(this.dataset.maxQuantity || 6);
    const stock = Number(variant?.inventory || maxSetting);
    const max = Math.max(1, Math.min(maxSetting, stock > 0 ? stock : maxSetting));
    this.quantity.max = max;
    this.quantity.value = Math.max(1, Math.min(max, Number(this.quantity.value || 1)));
  }
  async addToCart() {
    const variant = this.currentVariant();
    if (!variant?.available || this.isAdding) return;
    this.isAdding = true;
    this.addButton.disabled = true;
    this.addButton.setAttribute('aria-busy', 'true');
    if (this.message) this.message.textContent = 'Ajout en cours…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:variant.id, quantity:Number(this.quantity?.value || 1)}]})
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Cette sélection n’est plus disponible.');
      }
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      this.isAdding = false;
      this.addButton.removeAttribute('aria-busy');
      this.addButton.disabled = false;
      if (this.message) this.message.textContent = error.message || 'Impossible d’ajouter cette sélection au panier.';
    }
  }
}
if (!customElements.get('court-ticket-product')) customElements.define('court-ticket-product', CourtTicketProduct);

document.addEventListener('click', (event) => {
  const menu = event.target.closest('[data-menu-toggle]');
  if (menu) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.toggleAttribute('open');
    menu.setAttribute('aria-expanded', String(open));
  }
  if (event.target.matches('[data-cookie-close]')) {
    localStorage.setItem('ticket-cookie-choice', 'done');
    document.querySelector('[data-cookie-banner]')?.remove();
  }
});
document.addEventListener('DOMContentLoaded', () => {
  if (localStorage.getItem('ticket-cookie-choice')) document.querySelector('[data-cookie-banner]')?.remove();
});
